import React from 'react';
import {Box, styled} from '@mui/material';

const PolaroidComp = styled(props=>{
    let {
        className,
        width='250px',
        height='250px',
        src,
    } = props;
    return <Box src={src}
      className={className}
      component="img"
      width={width}
      height={height}/>
})`
    object-fit: cover;
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.5);
    border: 4px solid ${p=>p.theme.palette.common.white};
    border-radius: 4px;
`;

const Polaroid = props=><PolaroidComp {...props}/>;

export default Polaroid;
